import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { addUser } from "../../redux/actions/user/loginUserAction";
import styles from "./Login.module.css";

const Login = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const onFinish = async (values) => {
    setLoader(true);
    try {
      const resp = await dispatch(addUser(values));
      if (resp?.success === "success") {
        if (resp.isRequired) {
          window.location.href = "/auth/change-password";
        } else {
          window.location.href = "/dashboard";
        }
      }
    } finally {
      setLoader(false);
    }
  };

  const onFinishFailed = () => {
    setLoader(false);
    toast.error("Please check your username and password.");
  };

  return (
    <div className={styles.authShell}>
      <div className={styles.formCardWrap}>
        <div className={styles.formCard}>
          <div className={styles.formBrandMark}>ERP</div>
          <h2 className={styles.formHeading}>Sign in</h2>
          <p className={styles.formSubtitle}>Enter your credentials to access your dashboard.</p>

          <Form
            name="login"
            layout="vertical"
            size="large"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Username"
              name="username"
              rules={[{ required: true, message: "Please enter your username" }]}
            >
              <Input
                prefix={<UserOutlined style={{ color: "#94a3b8" }} />}
                placeholder="Username"
                autoComplete="username"
                allowClear
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Please enter your password" }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
                placeholder="Password"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit" loading={loader} block className={styles.signInBtn}>
                Sign in
              </Button>
            </Form.Item>
          </Form>

          <div className={styles.links}>
            <Link to="/auth/forgot-password">Forgot password?</Link>
            <Link to="/auth/signup">Create an account</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
